<!-- title -->
<div class="ts-modal-title">
  <ng-content></ng-content>
</div>

<!-- close button -->
<app-icon-close (click)="closeModal()" class="ts-modal-close"></app-icon-close>
